"use client"

import { MouseEventHandler } from "react"
import { OverlayButton } from "./OverlayButton"

export type ProductThumbnailProps = {
  side: "left" | "right"
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export const CarouselArrow = ({ side, disabled, onClick }: ProductThumbnailProps) => (
  <OverlayButton
    title={side === "left" ? "Zurück" : "Weiter"}
    iconName="keyboard_arrow_down"
    iconClassName={side === "right" ? "-rotate-90" : "rotate-90"}
    disabled={disabled}
    onClick={onClick}
  />
)
